/* eslint-disable no-irregular-whitespace */
import { motion } from "framer-motion";
import { Info, X } from "lucide-react";

export const CardUnavalableModal = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="bg-dark-selected-3 fixed inset-0 z-20 flex h-dvh items-center justify-center backdrop-blur-sm md:backdrop-blur-md"
    >
      <motion.div
        onClick={(e) => e.stopPropagation()}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        exit={{ opacity: 0, scale: 0.5 }}
        className="relative flex h-auto max-w-100 flex-col items-center rounded-lg bg-white px-8 py-6 lg:w-150"
      >
        <button
          // onClick={() => {
          //   useCardsStore.setState({ isCardUnavailableOpen: false });
          // }}
          className="absolute top-4 right-4"
        >
          <X className="size-5 hover:text-neutral-500" />
        </button>
        <div className="flex size-10 items-center justify-center rounded-full bg-[#FFD7D8]">
          <Info className="size-4.5 text-red-500" />
        </div>

        <h1 className="mt-2 text-2xl font-bold">Notice</h1>

        <p className="mt-2 text-center font-medium">
          Card creation is temporarily unavailable due to an upcoming system
          update. You’ll be notified as soon as the new update is ready to
          install
        </p>
      </motion.div>
    </motion.div>
  );
};

export const CardCreationNoticeModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="bg-dark-selected-3 h-[calc(100vh + 32px)] fixed inset-0 -top-12 -left-4 z-20 w-[calc(100%+32px)] overflow-hidden backdrop-blur-sm md:backdrop-blur-md"
    >
      <motion.div
        onClick={(e) => e.stopPropagation()}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        exit={{ opacity: 0, scale: 0.5 }}
        className={`font-urbanist bg-dark-background-alternate border-dark-stroke-3 absolute bottom-0 z-50 flex h-70 w-full max-w-full flex-col items-center overflow-hidden rounded-2xl border px-4 py-4 text-white backdrop-blur-md md:max-w-[400px] md:rounded-2xl lg:top-1/2 lg:bottom-auto lg:left-1/2 lg:max-w-110 lg:-translate-x-1/2 lg:-translate-y-1/2 lg:rounded-2xl lg:pb-6`}
      >
        <button
          onClick={() => {
            onClose();
          }}
          className="absolute right-10 lg:top-4 lg:right-4"
        >
          <X className="size-5 hover:text-neutral-500" />
        </button>
        <div className="bg-dark-primary-main flex size-10 items-center justify-center rounded-full">
          <Info className="text-dark-text-50 size-4.5" />
        </div>

        <h1 className="text-dark-text-50 mt-2 text-lg font-semibold">
          Card Creation Notice
        </h1>

        <p className="text-dark-text-50 mt-2 text-center text-sm font-medium">
          Card creation is currently processed manually.
          <br /> Please contact our support team on Telegram by clicking the
          button below to purchase your card. We’ll handle the setup for you and
          notify you once it’s ready. 🚀
        </p>

        <a
          href="https://t.me/dynascentglobalofficial"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 mt-4 inline-block w-75 cursor-pointer rounded px-4 py-2 text-sm">
            Contact Support
          </button>
        </a>
      </motion.div>
    </motion.div>
  );
};
